import { useSyncExternalStore } from "react";
import { exportStore } from "./index";
import type { ExportRecord, ExportStore } from "./types";

function getSnapshot(): ExportRecord[] {
  return exportStore.list();
}

const SERVER_SNAPSHOT: ExportRecord[] = [];
function getServerSnapshot(): ExportRecord[] {
  return SERVER_SNAPSHOT;
}

function subscribe(listener: () => void): () => void {
  return exportStore.subscribe(listener);
}

export interface UseExportsResult {
  records: ExportRecord[];
  create: ExportStore["create"];
  remove: ExportStore["remove"];
}

export function useExports(): UseExportsResult {
  const records = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );
  return {
    records,
    create: exportStore.create.bind(exportStore),
    remove: exportStore.remove.bind(exportStore),
  };
}
